// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dTwd","productName":"Table_productName__TqlR5"};